module.exports = __webpack_public_path__ + "static/vaccination-1a16d3c6cb33d747dd635c53df9b8e27.jpg";